// extracted by mini-css-extract-plugin
export default {"page":"DefaultPage_page__2JUpw"};